import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { useSelector } from "react-redux";

const COLORS = {
  light: ["#008000", "#CC0927"],
  dark: ["#78D672", "#CC0927"],
};

// Custom label rendering function
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ 
  cx, 
  cy, 
  midAngle, 
  innerRadius, 
  outerRadius, 
  value, 
  index 
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text 
      x={x} 
      y={y} 
      fill="white" 
      textAnchor="middle" 
      dominantBaseline="central"
      fontSize={14}
      fontWeight="500"
    >
    {`$${value.toLocaleString()}`}
    </text>
  );
};

const SalaryPieChart = ({ paidSalaries, pendingApprovals }) => {
  const { theme } = useSelector((state) => state.theme);

  const data = [
    { name: "Paid Salaries", value: paidSalaries },
    { name: "Pending Approvals", value: pendingApprovals },
  ];

  // Calculate dynamic dimensions based on screen width
  const getDimensions = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 640) return { // Mobile
      outerRadius: 70,
      innerRadius: 40,
      height: 250
    };
    if (screenWidth < 1280) return { // Tablet
      outerRadius: 85,
      innerRadius: 50,
      height: 280
    };
    return { // Desktop
      outerRadius: 100,
      innerRadius: 60,
      height: 300
    };
  };

  const dimensions = getDimensions();

  return (
    <div className={`p-4 border rounded-[20px] md:w-1/2 w-full ${
      theme === "dark" 
        ? "bg-[#212529] border-[#555657] text-white" 
        : "bg-[#F2F4F7] border-[#D8D8D8] text-black"
    }`}>
      <h2 className="text-lg font-semibold mb-4 capitalize">
        Pending Salary Analysis
      </h2>
      
      <div className="flex justify-center">
        <ResponsiveContainer width="100%" height={dimensions.height}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={100}
              innerRadius={0}
              paddingAngle={0}
              dataKey="value"
              label={renderCustomizedLabel}
              labelLine={false}
            >
              {data.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={COLORS[theme][index]} 
                  stroke="none"
                />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value, name) => [`$${value.toLocaleString()}`, name]}
              contentStyle={{
                backgroundColor: theme === "dark" ? "#222" : "#fff", 
                borderRadius: 5,
                border: `1px solid ${theme === "dark" ? "#555" : "#ddd"}`
              }}
              itemStyle={{
                color: theme === "dark" ? "white" : "black",
              }}
            />
            <Legend 
              layout="horizontal" 
              verticalAlign="bottom" 
              align="center"
              wrapperStyle={{
                color: theme === "dark" ? "white" : "black",
                paddingTop: "20px"
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SalaryPieChart;